class Header {


  constructor() {
    this.searchOpen = false;
    this.menuOpen = false;
    this.burgerOpen = false;
    this.sharingOpen = false;
    this.closeButton = false;


    this.searchToggle = document.querySelector('.js-search-toggle');
    this.burgerToggle = document.querySelector('.js-burger-toggle');
    this.burger = document.querySelector('.burger');
    this.searchFormDesktop = document.querySelector(".search-container--desktop");
    this.menuContainer = document.querySelector(".menu-container");
    this.searchFormInput = document.querySelector('.form__input--search');
    this.sharingButton = document.querySelector(".js-sharing-toggle");
    this.sharingList = document.querySelector(".sharing__list--level-1");
    this.closeSharingButton = document.querySelector(".sharing__icon--close");
    this.sharingIcon = document.querySelector(".svg-share");

    this.bindEvents();
  }

  bindEvents() {
    this.burgerToggle.addEventListener("click", (e) => {
      this.closeSearch();
      this.toggleBurger();
      this.toggleMenu();
    });

    this.sharingButton.addEventListener("click", (e) => {
      this.toggleMeta();
    });

    this.searchToggle.addEventListener("click", (e) => {
      this.closeMenu();
      this.closeBurger();
      this.toggleSearch();
    });

  }




  toggleMeta() {

    if (this.sharingOpen) {
      this.sharingList.classList.remove('sharing-open');
      this.sharingIcon.classList.remove('active')
      this.closeSharingButton.classList.remove('active')

      this.sharingOpen = false;
    } else {
      this.sharingList.classList.add('sharing-open');
      this.sharingIcon.classList.add('active')
      this.closeSharingButton.classList.add('active')

      this.sharingOpen = true;
    }
  }




  toggleBurger() {
    if (this.burgerOpen) {
      this.burger.classList.remove('burger-open');
      this.burgerOpen = false;
    } else {
      this.burger.classList.add('burger-open');
      this.burgerOpen = true;
    }
  }

  closeBurger() {
    this.burger.classList.remove('burger-open');
    this.burgerOpen = false;
  }

  toggleMenu() {
    if (this.menuOpen) {
      this.menuContainer.classList.remove('menu-open');
      this.menuOpen = false;
    } else {
      this.menuContainer.classList.add('menu-open');
      this.menuOpen = true;
    }

  }

  closeMenu() {
    this.menuContainer.classList.remove('menu-open');
    this.menuOpen = false;
  }

  toggleSearch() {
    if (this.searchOpen) {
      this.searchFormDesktop.classList.remove('search-open');
      this.searchOpen = false;
    } else {
      this.searchFormDesktop.classList.add('search-open');
      this.searchFormDesktop.querySelector('input').focus();
      this.searchOpen = true;
    }
  }




  closeSearch() {
    this.searchFormDesktop.classList.remove('search-open');
    this.searchOpen = false;
  }

}

export default Header;
